<template>
  <article class="slide">
    <slot></slot>
  </article>
</template>

<script>
export default {
  name: 'Slide',
  props: {
    price: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="scss" scoped>
.slide {
  color: white;
  width: 250px;
  height: 430px;
  text-align: center;
  display: block;
  opacity: 0;
  transition: opacity 300ms cubic-bezier(0.19, 1, 0.22, 1);
}

.is-selected {
  opacity: 1;
}

.slide /deep/ figure {
  height: 320px;
  position: relative;
  margin: 0 auto;
  width: 250px;
}
</style>
